/* Lasclay : visite des champs v2. Films commentés (lv-film) et vue panoramique (lv-panorama).
   Autonome : s'ajoute à lasclay-visite.js sans le modifier. Vanilla JS, aucune dépendance. */
(function () {
  'use strict';
  var mqReduit = window.matchMedia('(prefers-reduced-motion: reduce)');
  var economie = !!(navigator.connection && navigator.connection.saveData);
  var sansMouvement = function () { return mqReduit.matches || economie; };
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function once(el, key) { if (el['__lv' + key]) return false; el['__lv' + key] = true; return true; }
  var hlsNatif = null;
  function lectureHls() {
    if (hlsNatif === null) { var t = document.createElement('video'); hlsNatif = !!(t.canPlayType && t.canPlayType('application/vnd.apple.mpegurl')); }
    return hlsNatif;
  }
  function petitEcran() { return window.innerWidth < 768; }
  // Même choix de source que lasclay-visite.js : HLS sur téléphone s'il est lu nativement, sinon le MP4 le plus proche.
  function choisirSource(video) {
    var brut = (video.getAttribute('data-lv-sources') || '').split(';').filter(Boolean);
    var sources = brut.map(function (s) { var i = s.indexOf('|'); var cle = s.slice(0, i); return { hls: cle === 'hls', h: parseInt(cle, 10) || 0, url: s.slice(i + 1) }; }).filter(function (s) { return s.url; });
    var hls = sources.filter(function (s) { return s.hls; })[0];
    if (hls && petitEcran() && lectureHls()) return hls.url;
    sources = sources.filter(function (s) { return !s.hls; });
    if (!sources.length) return null;
    var cible = petitEcran() ? 720 : 1080;
    var shopify = sources.filter(function (s) { return s.h > 0; }).sort(function (a, b) { return a.h - b.h; });
    if (shopify.length) { for (var i = 0; i < shopify.length; i++) if (shopify[i].h >= cible) return shopify[i].url; return shopify[shopify.length - 1].url; }
    return sources[0].url;
  }
  /* ------------------------------------------------------------------
     Films commentés : légendes synchronisées, chapitres cliquables.
     Lecture automatique, muette, quand le film est à l'écran ; jamais si la personne a
     demandé moins d'animations (elle lance alors le film elle-même).
  ------------------------------------------------------------------ */
  // Son d'ambiance : un seul lecteur pour tous les films. Muet par défaut ; le visiteur l'active d'un
  // geste (exigé par les navigateurs), puis il suit les films : il joue quand l'un d'eux joue.
  var ambiance = null, sonActif = false;
  function boutonsSon() {
    $$('[data-lv-film-son]').forEach(function (b) {
      b.setAttribute('aria-pressed', sonActif ? 'true' : 'false');
      b.setAttribute('aria-label', b.getAttribute(sonActif ? 'data-on' : 'data-off'));
    });
  }
  function jouerSon() { if (sonActif && ambiance) { var p = ambiance.play(); if (p && p.catch) p.catch(function () {}); } }
  function couperSiAucunFilm() {
    setTimeout(function () {
      if (ambiance && !$$('[data-lv-film-video]').some(function (v) { return !v.paused; })) ambiance.pause();
    }, 60);
  }
  function hms(t) { t = Math.max(0, Math.floor(t || 0)); var s = t % 60; return Math.floor(t / 60) + ':' + (s < 10 ? '0' : '') + s; }
  function initFilms(root) {
    $$('[data-lv-film]', root).forEach(function (sec) {
      if (!once(sec, 'film')) return;
      var video = sec.querySelector('[data-lv-film-video]');
      if (!video) return;
      var sous = sec.querySelector('[data-lv-film-sous]'), btn = sec.querySelector('[data-lv-film-jouer]');
      var barre = sec.querySelector('[data-lv-film-barre]'), progres = sec.querySelector('[data-lv-film-progres]');
      var temps = sec.querySelector('[data-lv-film-temps]');
      var chapitres = $$('.lv-film__chapitre', sec).map(function (b) {
        return { el: b, debut: parseFloat(b.getAttribute('data-debut')) || 0, fin: parseFloat(b.getAttribute('data-fin')) || 0,
                 titre: (b.querySelector('strong') || {}).textContent || '', texte: (b.querySelector('.lv-film__texte') || {}).textContent || '' };
      });
      var liste = sec.querySelector('[data-lv-film-liste]');
      var courant = -1, visible = false, voulu = !sansMouvement(), pauseManuelle = false;
      video.muted = true; video.loop = true;
      function charger() {
        if (video.getAttribute('src')) return true;
        var url = choisirSource(video); if (!url) return false;
        video.src = url;
        video.addEventListener('playing', function () { sec.classList.add('is-playing'); });
        return true;
      }
      function lancer() { if (!charger()) return; var p = video.play(); if (p && p.catch) p.catch(function () {}); }
      function etat() {
        var joue = !video.paused;
        sec.classList.toggle('is-paused', !joue);
        btn.setAttribute('aria-label', btn.getAttribute(joue ? 'data-pause' : 'data-jouer'));
      }
      video.addEventListener('play', etat); video.addEventListener('pause', etat);
      var urlSon = sec.getAttribute('data-lv-son'), btnSon = sec.querySelector('[data-lv-film-son]');
      if (urlSon && btnSon) {
        btnSon.addEventListener('click', function () {
          if (!ambiance) { ambiance = new Audio(urlSon); ambiance.loop = true; ambiance.volume = 0.6; }
          sonActif = !sonActif; boutonsSon();
          if (sonActif) { if (video.paused) { pauseManuelle = false; voulu = true; lancer(); } jouerSon(); }
          else ambiance.pause();
        });
        video.addEventListener('play', jouerSon);
        video.addEventListener('pause', couperSiAucunFilm);
      }
      btn.addEventListener('click', function () {
        if (video.paused) { pauseManuelle = false; voulu = true; lancer(); } else { pauseManuelle = true; video.pause(); }
      });
      function montrer(i) {
        if (i === courant) return;
        courant = i;
        chapitres.forEach(function (c, j) { if (j === i) c.el.setAttribute('aria-current', 'true'); else c.el.removeAttribute('aria-current'); });
        sous.classList.remove('is-in');
        if (i < 0) return;
        var c = chapitres[i];
        setTimeout(function () {
          if (courant !== i) return;
          sous.querySelector('strong').textContent = c.titre;
          sous.querySelector('span').textContent = c.texte;
          sous.classList.add('is-in');
        }, 180);
        // garde le chapitre courant en vue dans la liste (format vertical : liste défilante)
        if (liste && liste.scrollHeight > liste.clientHeight + 4) {
          var haut = c.el.parentNode.offsetTop - liste.clientHeight / 3;
          liste.scrollTo({ top: Math.max(0, haut), behavior: 'smooth' });
        }
      }
      video.addEventListener('timeupdate', function () {
        var t = video.currentTime, d = video.duration || 0, idx = -1;
        for (var i = 0; i < chapitres.length; i++) if (t >= chapitres[i].debut && t < chapitres[i].fin) { idx = i; break; }
        montrer(idx);
        if (d) { var pc = t / d * 100; progres.style.width = pc + '%'; barre.setAttribute('aria-valuenow', Math.round(pc)); }
        temps.textContent = hms(t);
      });
      function aller(t) { if (!charger()) return; var go = function () { video.currentTime = t; lancer(); };
        if (video.readyState >= 1) go(); else video.addEventListener('loadedmetadata', go, { once: true }); }
      chapitres.forEach(function (c) { c.el.addEventListener('click', function () { pauseManuelle = false; voulu = true; aller(c.debut + 0.05); }); });
      function chercher(e) {
        var r = barre.getBoundingClientRect(), f = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
        if (video.duration) aller(f * video.duration); else if (chapitres.length) aller(0);
      }
      barre.addEventListener('click', chercher);
      barre.addEventListener('keydown', function (e) {
        if (!video.duration) return;
        if (e.key === 'ArrowRight') { aller(Math.min(video.duration - 0.1, video.currentTime + 5)); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { aller(Math.max(0, video.currentTime - 5)); e.preventDefault(); }
      });
      etat();
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) {
          visible = e[0].isIntersecting;
          if (visible && voulu && !pauseManuelle) lancer(); else if (!visible) video.pause();
        }, { threshold: 0.45 }).observe(video);
      }
    });
  }

  /* ------------------------------------------------------------------
     Vue panoramique : trois copies de la bande côte à côte, décalées pour boucler.
     Glisser, flèches, molette horizontale, pincer ou gyroscope (sur demande).
  ------------------------------------------------------------------ */
  function initPanoramas(root) {
    $$('[data-lv-pano]', root).forEach(function (sec) {
      if (!once(sec, 'pano')) return;
      var vues = $$('[data-lv-pano-vue]', sec), aiguille = sec.querySelector('.lv-pano__aiguille');
      var boussole = sec.querySelector('[data-boussole]'), aide = sec.querySelector('[data-aide]');
      var btnReel = sec.querySelector('[data-voir-reel]'), btnGyro = sec.querySelector('[data-gyro]');
      var panneaux = $$('.lv-pano__panneau', sec);
      var auto = sec.hasAttribute('data-auto') && !sansMouvement();
      var touche = false, visible = false, vue = null;
      // État par vue : yaw en fraction de tour [0,1), zoom, décalage vertical
      vues.forEach(function (v) {
        var d = parseFloat(v.getAttribute('data-depart')); v.__yaw = isNaN(d) ? 0.5 : d / 100;
        v.__zoom = 1; v.__dy = 0; v.__boucle = v.hasAttribute('data-boucle');
        var r = (v.getAttribute('data-reel') || '0,100').split(',').map(parseFloat); v.__reel = r;
      });
      function dims(v) {
        var H = v.clientHeight * v.__zoom, ratio = parseFloat(v.getAttribute('data-ratio')) || 4;
        return { H: H, W: H * ratio, vw: v.clientWidth, vh: v.clientHeight };
      }
      function rendre(v) {
        var d = dims(v), piste = v.querySelector('[data-piste]');
        if (!v.__boucle) { // bande partielle : on bute aux bords
          var demi = d.vw / 2 / d.W; v.__yaw = Math.min(1 - demi, Math.max(demi, v.__yaw));
        } else { v.__yaw = ((v.__yaw % 1) + 1) % 1; }
        var maxDy = Math.max(0, (d.H - d.vh) / 2); v.__dy = Math.min(maxDy, Math.max(-maxDy, v.__dy));
        var x = d.vw / 2 - (d.W + v.__yaw * d.W), y = (d.vh - d.H) / 2 + v.__dy;
        piste.style.width = (d.W * 3) + 'px'; piste.style.height = d.H + 'px';
        piste.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0)';
        $$('.lv-pano__tuile', piste).forEach(function (t) { t.style.width = d.W + 'px'; t.style.height = d.H + 'px'; });
        if (aiguille) aiguille.style.transform = 'rotate(' + (v.__yaw * 360).toFixed(1) + 'deg)';
        if (boussole) {
          var a = v.__reel[0] * 3.6, b = v.__reel[1] * 3.6;
          boussole.style.setProperty('--reel-a', a + 'deg'); boussole.style.setProperty('--reel-b', b + 'deg');
        }
      }
      function activer(n) {
        vues.forEach(function (v) { var on = v.getAttribute('data-station') === String(n); v.hidden = !on; v.classList.toggle('is-active', on); if (on) vue = v; });
        $$('[data-aller]', sec).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-aller') === String(n) ? 'true' : 'false'); });
        fermer(); rendre(vue);
      }
      vue = vues.filter(function (v) { return !v.hidden; })[0] || vues[0];
      if (!vue) return;
      $$('[data-aller]', sec).forEach(function (b) { b.addEventListener('click', function () { activer(b.getAttribute('data-aller')); }); });

      function marquer() { if (!touche) { touche = true; sec.classList.add('is-touche'); } }
      // Glisser, avec inertie
      var glisse = null, vitesse = 0, inertie = null;
      function tourner(dxPx, dyPx) { var d = dims(vue); vue.__yaw -= dxPx / d.W; vue.__dy += dyPx || 0; rendre(vue); }
      vues.forEach(function (v) {
        var pointeurs = {};
        v.addEventListener('pointerdown', function (e) {
          if (e.target.closest('.lv-pano__point')) return;
          pointeurs[e.pointerId] = { x: e.clientX, y: e.clientY };
          if (Object.keys(pointeurs).length === 2) { var p = Object.keys(pointeurs).map(function (k) { return pointeurs[k]; }); v.__pince = { d: Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y), z: v.__zoom }; glisse = null; return; }
          glisse = { x: e.clientX, y: e.clientY, t: performance.now() }; vitesse = 0; cancelAnimationFrame(inertie);
          v.setPointerCapture(e.pointerId); v.classList.add('is-glisse'); marquer();
        });
        v.addEventListener('pointermove', function (e) {
          if (pointeurs[e.pointerId]) pointeurs[e.pointerId] = { x: e.clientX, y: e.clientY };
          if (v.__pince && Object.keys(pointeurs).length === 2) {
            var p = Object.keys(pointeurs).map(function (k) { return pointeurs[k]; });
            v.__zoom = Math.min(2.6, Math.max(1, v.__pince.z * Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y) / v.__pince.d)); rendre(v); return;
          }
          if (!glisse) return;
          var now = performance.now(), dx = e.clientX - glisse.x, dy = e.clientY - glisse.y;
          vitesse = dx / Math.max(8, now - glisse.t);
          glisse = { x: e.clientX, y: e.clientY, t: now };
          tourner(dx, dy);
        });
        function fin(e) {
          delete pointeurs[e.pointerId]; if (Object.keys(pointeurs).length < 2) v.__pince = null;
          if (!glisse) return; glisse = null; v.classList.remove('is-glisse');
          var vx = vitesse * 16;
          (function elan() { if (Math.abs(vx) < 0.3) return; tourner(vx, 0); vx *= 0.93; inertie = requestAnimationFrame(elan); })();
        }
        v.addEventListener('pointerup', fin); v.addEventListener('pointercancel', fin);
        v.addEventListener('wheel', function (e) {
          if (e.ctrlKey) { e.preventDefault(); v.__zoom = Math.min(2.6, Math.max(1, v.__zoom * (e.deltaY < 0 ? 1.08 : 0.93))); rendre(v); marquer(); return; }
          if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) { e.preventDefault(); tourner(-e.deltaX, 0); marquer(); }
        }, { passive: false });
        v.addEventListener('keydown', function (e) {
          var pas = dims(v).vw / 6;
          if (e.key === 'ArrowLeft') { tourner(pas, 0); marquer(); e.preventDefault(); }
          else if (e.key === 'ArrowRight') { tourner(-pas, 0); marquer(); e.preventDefault(); }
          else if (e.key === '+' || e.key === '=') { v.__zoom = Math.min(2.6, v.__zoom * 1.2); rendre(v); e.preventDefault(); }
          else if (e.key === '-') { v.__zoom = Math.max(1, v.__zoom / 1.2); rendre(v); e.preventDefault(); }
        });
      });
      $$('[data-zoom]', sec).forEach(function (b) {
        b.addEventListener('click', function () { var s = parseFloat(b.getAttribute('data-zoom')); vue.__zoom = Math.min(2.6, Math.max(1, vue.__zoom * (s > 0 ? 1.25 : 0.8))); rendre(vue); marquer(); });
      });
      // Points d'intérêt (chaque point existe en trois copies : on ouvre le même panneau)
      function fermer() {
        $$('.lv-pano__point', sec).forEach(function (p) { p.setAttribute('aria-expanded', 'false'); });
        panneaux.forEach(function (p) { p.classList.remove('is-open'); p.setAttribute('aria-hidden', 'true'); });
      }
      $$('.lv-pano__point', sec).forEach(function (p) {
        p.addEventListener('click', function (e) {
          e.stopPropagation(); marquer();
          var id = p.getAttribute('data-panneau'), deja = p.getAttribute('aria-expanded') === 'true';
          fermer(); if (deja) return;
          $$('[data-panneau="' + id + '"]', sec).forEach(function (x) { x.setAttribute('aria-expanded', 'true'); });
          var pn = document.getElementById(id); if (pn) { pn.classList.add('is-open'); pn.setAttribute('aria-hidden', 'false'); }
        });
      });
      panneaux.forEach(function (pn) { var f = pn.querySelector('.lv-panneau__fermer'); if (f) f.addEventListener('click', fermer); });
      sec.addEventListener('keydown', function (e) { if (e.key === 'Escape') fermer(); });
      // Ce qui est réel / complété par IA
      if (btnReel) btnReel.addEventListener('click', function () {
        var on = btnReel.getAttribute('aria-pressed') !== 'true';
        btnReel.setAttribute('aria-pressed', on ? 'true' : 'false'); sec.classList.toggle('is-reel', on);
      });
      // Gyroscope : seulement sur un appareil qui en a un, et sur demande (iOS exige un geste)
      var gyroBase = null;
      function surOrientation(e) {
        var cap = e.webkitCompassHeading != null ? -e.webkitCompassHeading : e.alpha;
        if (cap == null) return;
        if (!gyroBase) { gyroBase = { cap: cap, yaw: vue.__yaw, beta: e.beta || 0, dy: vue.__dy }; return; }
        var delta = cap - gyroBase.cap; if (delta > 180) delta -= 360; if (delta < -180) delta += 360;
        vue.__yaw = gyroBase.yaw - delta / 360;
        vue.__dy = gyroBase.dy + ((e.beta || 0) - gyroBase.beta) * dims(vue).H / 120;
        rendre(vue);
      }
      if (btnGyro && window.DeviceOrientationEvent && ('ontouchstart' in window)) {
        btnGyro.hidden = false;
        btnGyro.addEventListener('click', function () {
          var on = btnGyro.getAttribute('aria-pressed') === 'true';
          if (on) { window.removeEventListener('deviceorientation', surOrientation); btnGyro.setAttribute('aria-pressed', 'false'); return; }
          var go = function () { gyroBase = null; window.addEventListener('deviceorientation', surOrientation); btnGyro.setAttribute('aria-pressed', 'true'); marquer(); };
          if (typeof DeviceOrientationEvent.requestPermission === 'function') {
            DeviceOrientationEvent.requestPermission().then(function (r) { if (r === 'granted') go(); }).catch(function () {});
          } else go();
        });
      }
      // Rotation lente tant que personne n'a touché, et seulement à l'écran
      var dernier = 0;
      function tourne(t) {
        if (!visible || touche || !auto) return;
        if (dernier) { var d = dims(vue); vue.__yaw += (t - dernier) / 1000 * (d.vw / d.W) / 22; rendre(vue); }
        dernier = t; requestAnimationFrame(tourne);
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { visible = e[0].isIntersecting; dernier = 0; if (visible) requestAnimationFrame(tourne); }, { threshold: 0.3 }).observe(sec);
      }
      $$('.lv-pano__img', sec).forEach(function (im) { if (!im.complete) im.addEventListener('load', function () { rendre(vue); }); });
      window.addEventListener('resize', function () { rendre(vue); });
      rendre(vue);
    });
  }


  function initTout(root) { initFilms(root); initPanoramas(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTout(document); }); else initTout(document);
  document.addEventListener('shopify:section:load', function (e) { initTout(e.target); });
})();
